<div class="text-center">
    <img src="assets/img/StaffingGo.png" alt="Password" width="80%" class="img-responsive big-logo" *ngIf="isShowImgLogo === false">
    <img [src]="getImgLogo | safe:'resourceUrl'" alt="Password" width="80%" class="img-responsive big-logo" *ngIf="isShowImgLogo === true">
</div>
<div class="fz-18 text-center my-3"><b>Enter New Password</b></div>
<div class="alert alert-danger text-center p-2 m-1" role="alert" *ngIf="errMsg">
    <div>{{errMsg}}</div>
</div>
<form (submit)="fnNewPassword(newPasswordModel)">
    <dx-form id="form" [formData]="newPasswordModel" [colCount]="4" labelLocation="top" [showColonAfterLabel]="false">
        <dxi-item [label]="{visible:false}" dataField="consPass" editorType="dxTextBox" [editorOptions]="{ mode: 'password',placeholder:'Password'}" [colSpan]="4" id="btn">
            <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="passwordPattern" message="Minimum 8 characters
        At least one uppercase character
        At least one lowercase character
        At least one special character">
            </dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{visible:false}" dataField="reConsPass" editorType="dxTextBox" [editorOptions]="{ mode: 'password',placeholder:'Confirm Password'}" [colSpan]="4">
            <dxi-validation-rule type="required" message="Confirm Password is required"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="passwordPattern" message="Minimum 8 characters
        At least one uppercase character
        At least one lowercase character
        At least one special character">
            </dxi-validation-rule>
        </dxi-item>
        <!-- <dxi-item itemType="button" [editorOptions]="{ mode:'password'}" cssClass="password-btn"
        horizontalAlignment="center" [colSpan]="4" [buttonOptions]="passwordBtn">
      </dxi-item> -->
        <dxi-item itemType="button" horizontalAlignment="center" [colSpan]="4" [buttonOptions]="custNewPasswd">
        </dxi-item>
    </dx-form>
    <dx-tooltip target="input[id*='consPass']" showEvent="mouseenter" position="right" hideEvent="mouseleave">
        <div *dxTemplate="let data = data of 'content'">
            <p>Length greater than 8 characters</p>
            <p>Uppercase character</p>
            <p>Lowercase character</p>
            <p>1 Numerical character</p>
            <p>1 Special character</p>

        </div>
    </dx-tooltip>
    <dx-tooltip target="input[id*='reConsPass']" showEvent="mouseenter" position="right" hideEvent="mouseleave">
        <div *dxTemplate="let data = data of 'content'">
            <p>Password & Confirm Password must be same</p>
        </div>
    </dx-tooltip>
</form>